
import HeaderTitulo from "../../components/header-titulo";
import AditivoService from "../../services/aditivoService";
// import { saveAs } from "file-saver";

export default {
  name: "comprovacaoRural",
  props: ["propostaResponse"],
  components: { HeaderTitulo },
  data () {
    return {
      proposta: null,
      enquadramento: null,
      isLoadingUpload: false,
      radioValue: false,
      checkboxValue: false,
      justificativa: null,
    };
  },
  mounted () {
    this.init();
  },
  watch: {},
  computed: {},
  methods: {
    init () {
      this.proposta = this.propostaResponse;
    },
    validacaoFormulario: function () {

      if (this.enquadramento == null) {
        this.$b.nWarning("Marque uma alternativa para enquadramento.");
        return false;
      }

      if (this.checkboxValue == false) {
        this.$b.nWarning(
          "É necessário assinalar a declaração para prosseguir."
        );
        return false;
      }
      return true;
    },
    uploadArquivo () {
      if (this.validacaoFormulario() === false) {
        return
      }
      this.sendFileToServer()
    },
    sendFileToServer () {
      this.$q.loading.show()
      this.isLoadingUpload = true;
      const request = {
        idPropostaRepactuacao: this.proposta.idPropostaRepactuacao,
        enquadramento: this.enquadramento,
        faturamento1: 0,
        faturamento2: 0,
      };

      AditivoService.uploadComprovacao(
        request,
        undefined,
        null,
        this.proposta.idPropostaRepactuacao,
        this.proposta.chave
      ).then((res) => {
        if (res.data.code === 99) {
          this.$b.nError(`${res.data.message}`);
          return;
        }
        this.$router.push({
          name: "aditivo",
          params: { propostaResponse: this.proposta },
        });
      })
        .catch((err) => {
          this.$b.nError(`${err.data.message}`);
        })
        .finally(() => {
          this.isLoadingUpload = false
          this.$q.loading.hide();
        });
    },
    /**
     * Converte File para Base64
     * @param {File} file
     * @returns {Promise<String>}
     */
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    /**
     *
     * @param {File} file
     */
    getTipoArquivo (file) {
      return file.type === "application/pdf" ? "PDF" : "JPG";
    },
  },
  beforeMount () {
    this.init();
  }
}

